// Echoes the chosen variant option next to its label, the way the reference
// product pages read "Size  S  In Stock" on one line.
//
// Horizon replaces the picker's markup wholesale when the variant changes, so
// the listener is delegated from the document rather than bound to the radios
// themselves — bound listeners would not survive the morph.
class SelectedOption extends HTMLElement {
  connectedCallback() {
    this.option = (this.getAttribute('option') || '').toLowerCase();
    this.onChange = this.onChange.bind(this);
    document.addEventListener('change', this.onChange);
    this.sync();
  }

  disconnectedCallback() {
    document.removeEventListener('change', this.onChange);
  }

  onChange(event) {
    if (event.target instanceof HTMLInputElement && event.target.type === 'radio') {
      this.sync();
    }
  }

  sync() {
    const fieldsets = document.querySelectorAll('.product-information .variant-option');
    for (const fieldset of fieldsets) {
      const legend = fieldset.querySelector('legend');
      const name = legend ? legend.textContent.trim().toLowerCase() : '';
      if (this.option && name !== this.option) continue;
      const checked = fieldset.querySelector('input:checked');
      if (checked) {
        this.textContent = checked.value;
        return;
      }
    }
    this.textContent = '';
  }
}

if (!customElements.get('selected-option')) {
  customElements.define('selected-option', SelectedOption);
}
